import {
  Box,
  Button,
  Center,
  Checkbox,
  HStack,
  Input,
  Select,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Th,
  Thead,
  Tr,
  useToast
} from '@chakra-ui/react'
import React, {useState} from "react";
import {useMutation, useQuery, useQueryClient} from "react-query";

import {deleteUser, getUsers} from "../../shared/Api";
import {errorToast, successToast} from "../../shared/helper/ToastHelper";
import {UserStatus} from "../../shared/model/Constants";
import {UserDto} from "../../shared/model/Dto";
import {adminKeys} from "../../shared/QueryKeys";
import {extractData, includedInFilter} from "../../shared/Utils";
import UserSummaryItem from "./UserSummaryItem";

const UsersList = () => {
  const queryClient = useQueryClient();
  const toast = useToast();

  const [institutionValue, setInstitutionValue] = useState<string>("");
  const [regionValue, setRegionValue] = useState<string>("");
  const [groupValue, setGroupValue] = useState<string>("");

  const [idValue, setIdValue] = useState<string>("");
  const [nameValue, setNameValue] = useState<string>("");
  const [emailValue, setEmailValue] = useState<string>("");

  const [includeAvailable, setIncludeAvailable] = useState<boolean>(true);
  const [includeReserved, setIncludeReserved] = useState<boolean>(true);
  const [includeUsed, setIncludeUsed] = useState<boolean>(true);

  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(25);

  function filterUsers(data: UserDto[]) {
    return data.filter(user =>
      includedInFilter(user.institution, institutionValue) &&
      includedInFilter(user.region, regionValue) &&
      includedInFilter(user.uGroup, groupValue) &&
      includedInFilter(user.username, idValue) &&
      includedInFilter(user.name, nameValue) &&
      includedInFilter(user.email, emailValue) &&
      ( includeAvailable && user.status === UserStatus.AVAILABLE ||
        includeReserved && user.status === UserStatus.RESERVED ||
        includeUsed && user.status === UserStatus.USED )
    );
  }
  const usersQuery = useQuery(adminKeys.users(), () =>
    getUsers(institutionValue, regionValue, groupValue).then(extractData)
  );
  
  const deleteUserMutation = useMutation(deleteUser, {
    onSuccess: () => {
      successToast(toast, "Usuario eliminado");
      return queryClient.invalidateQueries(adminKeys.users());
    },
    onError: () => {
      errorToast(toast, "Error eliminando usuario");
    },
  });
  
  if (!usersQuery.data) {
    return (
      <Center height="200px">
        <Spinner />
      </Center>
    );
  } else {
    return (
      <Box width="95%" marginX="auto">
        <div onChange={()=>setPage(0)}>
          <HStack alignSelf="start" spacing={10} paddingY={1}>
            <Input placeholder='Identificación' onChange={(event)=>setIdValue(event.target.value)}/>
            <Input placeholder='Nombre' onChange={(event)=>setNameValue(event.target.value)} />
            <Input placeholder='Correo' onChange={(event)=> setEmailValue(event.target.value)}/>
          </HStack >
          <HStack alignSelf="start" spacing={10} paddingY={1}>
            <Input placeholder='Institución' onChange={(event)=>setInstitutionValue(event.target.value)}/>
            <Input placeholder='Región' onChange={(event)=>setRegionValue(event.target.value)} />
            <Input placeholder='Grupo' onChange={(event)=> setGroupValue(event.target.value)}/>
          </HStack >
          <HStack alignSelf="start" spacing={10} paddingY={1}>
            <Checkbox minW="fit-content"
                      onChange={async (e) => {
                        setIncludeAvailable(e.target.checked);
                        return usersQuery.refetch();
                      }}
                      defaultChecked={includeAvailable}>
              Usuarios disponibles
            </Checkbox>
            <Checkbox minW="fit-content"
                      onChange={async (e) => {
                        setIncludeReserved(e.target.checked);
                        return usersQuery.refetch();
                      }}
                      defaultChecked={includeReserved}>
              Licencias reservadas
            </Checkbox>
            <Checkbox minW="fit-content"
                      onChange={async (e) => {
                        setIncludeUsed(e.target.checked);
                        return usersQuery.refetch();
                      }}
                      defaultChecked={includeUsed}>
              Licencias usadas
            </Checkbox>
          </HStack >
          <HStack alignSelf="start" spacing={10} paddingY={1}>
            <Select value={pageSize.toString()} isReadOnly={true} width="1xs"
                    onChange={(event)=> {setPageSize(parseInt(event.target.value)); }}>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={250}>250</option>
              <option value={filterUsers(usersQuery.data).length}>Todos</option>
            </Select>
            {usersQuery.isFetching &&
              <Spinner />
            }
          </HStack >
        </div>

        <TableContainer width="95vw">
        <Table size='sm' variant='striped' whiteSpace="normal">
          <Thead>
            <Tr>
              <Th>Identificación</Th>
              <Th>Nombre</Th>
              <Th>Institución</Th>
              <Th>Región</Th>
              <Th>Correo</Th>
              <Th>Grupo</Th>
              <Th>Rol</Th>
              <Th>Licencia</Th>
              <Th> </Th>
              <Th> </Th>
            </Tr>
          </Thead>

          <Tbody key="List">
            {usersQuery.isSuccess && usersQuery.data.length ? (
                  filterUsers(usersQuery.data).slice(page, page+pageSize).map((user) => (
                        <UserSummaryItem user={user}
                           onUserDeleted={(username) => deleteUserMutation.mutate(username)}
                        />
                    ))
            ) : (
                <Tr key={"empty"}>
                </Tr>
            )}

          </Tbody>
        </Table>
      </TableContainer>
        <HStack paddingY={10} justifyContent="end">
          <Button
            colorScheme="teal"
            disabled={page === 0}
            onClick={()=>setPage(page-pageSize)}
          >
            Anterior
          </Button>
          <Button
            colorScheme="teal"
            disabled={page+pageSize >= filterUsers(usersQuery.data).length}
            onClick={()=>setPage(page+pageSize)}
          >
            Siguiente
          </Button>
        </HStack>
      </Box>
    );
  }
};

export default UsersList;
